import React, {
  useRef,
  useState,
  useContext,
  useEffect
}                                         from 'react';

import { useTranslation}                  from 'react-i18next';
import PeoplesContext                     from './context';
import { People }                         from '@material-ui/icons';
import List                               from '~/containers/List';
import {
  showPerson,
  editPerson,
  newPerson,
  examsPerson }                           from '~/config/routes';
import PushModal                          from './components/PushModal';
import MedicPushModal                     from './components/MedicPushModal';
import userColumns                        from '~/config/customQuery/userConfig';
import Request                            from '~/providers/Request';
import csvGenerator                       from '~/utils/csvGenerator';
import { toast }                          from 'react-toastify';
import moment                             from 'moment';
import CurrentUser                        from '~/contexts/CurrentUser';
import { AbilityContext }                 from '~/contexts/Can';
import ModalTerms from '../../components/Modal/ModalTerms';

function PeoplesList() {
  const { t } = useTranslation();
  const listEl = useRef(null);
  const [modalInfo, setModalInfo] = useState({visible:false});
  const [modalMedic, setModalMedic] = useState({visible:false});
  const { user } = useContext(CurrentUser);
  const ability = useContext(AbilityContext);

  const actions = [
    'search',
    'filter',
    'export',
  ];

  // Botao de exames (Comigo Connect) desativado: o SDK Comigo esta comentado no
  // public/index.html, entao a tela /clientes/exams/:id fica quebrada. Codigo
  // mantido — basta reativar este bloco + o script do Comigo para voltar.
  // if(ability.can('exam', 'Peoples')) {
  //   actions.push('exams');
  // }
  if(ability.can('new', 'Peoples')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Peoples')) {
    actions.push('edit');
  }
  if(ability.can('show', 'Peoples')) {
    actions.push('show');
  }
  if(ability.can('new', 'Pushs')) {
    actions.push('modalPush');
    actions.push('modalCancel');
    actions.push('modalMedic');
  }

  function openScheduleModal(id, name) {
    setModalInfo({...modalInfo, id, name, doctor_schedule: true, visible: true});
  }

  function openCancelModal(id, name) {
    setModalInfo({...modalInfo, id, name, doctor_schedule: false, visible: true});
  }

  function openMedicModal(id, name){
    setModalMedic({...modalMedic, id, name, visible: true});
  }

  useEffect(() => {
  }, []);

  function generateCSV() {
    toast.info('Arquivo CSV esta sendo gerado!');

    const fields = 'id-name-email-cell_phone-created_at-signature_first_date-last_sign_state';
    const params = function() {
      const vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
          vars[key] = value;
      });

      return vars;
    };

    Request.get('/admin/users/', { ...params(), csv: true, fields })
      .then(response => {
        const dateFormat = date => date && moment(date).format('DD/MM/YYYY HH:mm:ss');
        const headers = ['ID', 'Nome', 'Email', 'Telefone', 'Data de Cadastro', 'Primeira Assinatura', 'Status assinatura'];
        const rows = response.data.map(client => {
          const createdAt = dateFormat(client.created_at);
          const signature = dateFormat(client.signature_first_date);

          return [client.id, client.name, client.email, client.cell_phone, createdAt, signature, client.last_sign_state];
        });

        csvGenerator('televida-customers.csv', [headers, ...rows]);

        toast.success('Arquivo CSV de clientes gerado com sucesso!');
      })
      .catch(err => {
        toast.error('Não foi possível gerar o arquivo CSV dos clientes');
        console.error('[ERROR to generateCSV]', err);
      });
  }

  if(user)
    return (
      <>
        <ModalTerms />
        <List
          routeToShow={showPerson}
          routeToEdit={editPerson}
          routeToNew={newPerson}
          routeToExams={examsPerson}
          pushModalAction={openScheduleModal}
          cancelModalAction={openCancelModal}
          modalMedicAction={openMedicModal}
          listEl={listEl}
          path={'/admin/users/'}
          actions={actions}
          onExport={generateCSV}
          paperProps={{
            Icon:People,
            iconColor:'blue',
            title:t('person.defPlural'),
          }}
          columns={userColumns()}
          context={PeoplesContext}
          recordMap={
            record => ({
              ...record,
              partner: record.partner ? record.partner.name : '',
              created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
              expires_at: record.expires_at ? moment(record.expires_at).format('DD/MM/YYYY HH:mm') : null,
              updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
            })
          }
        />
        <PushModal
          open={modalInfo.visible}
          onClose={() => setModalInfo({visible: false})}
          name={modalInfo.name}
          id={modalInfo.id}
          doctor_schedule={modalInfo.doctor_schedule}
        />
        <MedicPushModal
          open={modalMedic.visible}
          onClose={() => setModalMedic({visible: false})}
          name={modalMedic.name}
          id={modalMedic.id}
        />
      </>
    );
}

export default React.memo(PeoplesList);
